import { tieneValor, formatear } from './catalogo';
import { fechaDetalle } from './detalleVenta';

const texto = valor => tieneValor(valor) && ['string', 'number'].includes(typeof valor) && String(valor).trim() ? String(valor).trim() : 'No registrado';
const numero = valor => tieneValor(valor) && Number.isFinite(Number(valor)) ? Number(valor) : null;
const dinero = valor => numero(valor) === null ? 'No registrado' : 'RD$ ' + formatear(valor, 'moneda');
const campo = (titulo, valor) => ({ titulo, valor: texto(valor) });

export function detalleCierreViaje(datos = {}) {
  const r = datos.registro || {}, lista = (datos.detalles || {}).tickets || {};
  const total = numero(lista.total), pagina = Math.max(1, numero(lista.pagina) || 1), tamano = Math.max(1, numero(lista.tamano) || 50);
  return {
    numero: texto(r.id), viaje: texto(r.numero_viaje), fecha: texto(fechaDetalle(r.fecha_presentacion || r.fecha, true)),
    campos: [campo('Ficha', r.ficha), campo('Cajero', r.cajero), campo('Sucursal cierre', r.nombre_sucursal_cierre),
      campo('Sucursal cerrada', r.nombre_sucursal_cerrada), campo('Turno detalle', r.turno_detalle), campo('Cierre de caja', r.cierre_caja)],
    importes: [
      ['Cortesias', 'valor_boletos_cortesia'], ['Descuentos', 'valor_descuento'], ['Recargos', 'valor_recargos'],
      ['Abordados', 'valor_abordo'], ['No abordados', 'valor_no_abordo'], ['Dieta', 'dieta_descontar'],
      ['Comision', 'comision_descontar'], ['Otros descuentos', 'otros_montos_descontar'],
    ].map(([titulo, clave]) => campo(titulo, dinero(r[clave]))),
    totalCierre: dinero(r.total),
    boletos: (Array.isArray(lista.filas) ? lista.filas : []).map(boleto => ({ numero: texto(boleto.id), ruta: texto(boleto.ruta), importe: dinero(boleto.precio_total) })),
    disponibles: Array.isArray(lista.filas), totalBoletos: texto(total), importeBoletos: dinero((lista.resumen || {}).precio_total),
    pagina, paginas: Math.max(1, Math.ceil((total || 0) / tamano)),
  };
}
